import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

// Should fetch same nodes as FlowDownstreamOwnerIdsQuery
export const FlowDownstreamOwnersQueryGql: DocumentNode = gql`
query FlowDownstreamOwnersQuery($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowDataFragment
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
